// Application configuration
const config = {
  apiUrl: import.meta.env.VITE_API_URL || '/', // Slash = always resolve from root, not relative to current page
};

/**
 * Dev-only auth bypass: skips Clerk entirely and sends no Authorization header.
 * `import.meta.env.DEV` is statically false in production builds, so this is
 * always false there regardless of VITE_DEV_AUTH_BYPASS.
 */
export const DEV_AUTH_BYPASS =
  import.meta.env.DEV && import.meta.env.VITE_DEV_AUTH_BYPASS === 'true';

export default config;
